import { render, staticRenderFns } from "./add-task.vue?vue&type=template&id=68b65ea6&scoped=true&"
import script from "./add-task.vue?vue&type=script&lang=js&"
export * from "./add-task.vue?vue&type=script&lang=js&"
import style0 from "./add-task.vue?vue&type=style&index=0&id=68b65ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b65ea6",
  null
  
)

export default component.exports